module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_person-0e1052187e048bc1c39e7b481f32a996.svg";